/**
 * Performance monitoring with Bugsnag: page loads (with the web vitals), route changes and the requests to the API. Only
 * enabled when the build has an API key (`BUGSNAG_API_KEY` at build time), as the error reporting (see
 * `error-reporter.ts`).
 */
import BugsnagPerformance, {DefaultRoutingProvider} from '@bugsnag/browser-performance';

const apiKey = __BUGSNAG_API_KEY__;

/**
 * the terminal checking every minute whether a newer build is deployed (see `app-update.ts`): no request of the user's.
 * Requests reach Bugsnag with their absolute URL.
 */
const updateCheckUrl = new RegExp(
    `^${window.location.origin.replace(/[.*+?^${}()|[\]\\/]/g, '\\$&')}/version\\.json(\\?|$)`,
);

let started = false;

/**
 * Start measuring. `resolveRoute` names the route of a URL (e.g. `/terminal`), which page loads and route changes are
 * grouped by.
 */
export const startPerformanceMonitoring = (resolveRoute: (url: URL) => string): void => {
    if (!apiKey || started) {
        return;
    }

    BugsnagPerformance.start({
        apiKey,
        // the same app version as the errors (see `error-reporter.ts`)
        appVersion: __BUILD_ID__,
        // react-router changes the route through `history.pushState`, which the default routing provider listens for
        routingProvider: new DefaultRoutingProvider(resolveRoute),
        // the update check is no request of a page: it neither delays a page from settling nor gets a span
        settleIgnoreUrls: [updateCheckUrl],
        networkRequestCallback: requestInfo => (updateCheckUrl.test(requestInfo.url ?? '') ? null : requestInfo),
    });

    started = true;
};
